// features/admin/adminApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://api.codebondingworkforce.com/api',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Admins', 'RechargeHistory'],
  endpoints: (builder) => ({
    registerAdmin: builder.mutation({
      query: (userId) => ({
        url: '/admin-portal/register',
        method: 'POST',
        body: { userId }
      }),
      invalidatesTags: ['Admins']
    }),
    getAdmins: builder.query({
      query: () => '/admin-portal/admins',
      providesTags: ['Admins']
    }),
    getRechargeHistory: builder.query({
      query: ({ search, name, status, page, limit }) => ({
        url: '/mobile-recharge/admin/history-for-user',
        params: { search, name, status, page, limit }
      }),
      providesTags: ['RechargeHistory']
    })
  })
});

export const { 
  useRegisterAdminMutation,
  useGetAdminsQuery,
  useGetRechargeHistoryQuery
} = adminApi;